import { render, staticRenderFns } from "./CreateApiToken.vue?vue&type=template&id=5766692e&scoped=true"
import script from "./CreateApiToken.vue?vue&type=script&lang=js"
export * from "./CreateApiToken.vue?vue&type=script&lang=js"
import style0 from "./CreateApiToken.vue?vue&type=style&index=0&id=5766692e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766692e",
  null
  
)

export default component.exports